import { ShopStatus } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { createAppAsyncThunk } from 'src/state/thunk-api';
import { handleError } from 'src/utils/error-utils';

export const fetchShopStatusActionCreator = createAppAsyncThunk<ShopStatus>('request/fetchShopStatus', async () => {
  try {
    return await api.shopController.getShopStatus();
  } catch (error: any) {
    handleError(error);
    return Promise.reject();
  }
});
